
<div [innerHtml]="tranform(middledata.text1)"> </div>